import request from '@/utils/request'

export function getMasterDataGovernanceOverview () {
  return request({
    url: '/addon/masterDataGovernance/overview',
    method: 'get'
  })
}
